export default __webpack_public_path__ + "f172feda865fd7fc069e47e74c18c629.svg";